





































































import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import {namespace} from 'vuex-class';
import {ReviewRate} from '@/store/RateReviewFaq/types';
import BIcon from 'buefy/src/components/icon/Icon.vue';
import BInput from 'buefy/src/components/input/Input.vue';
import BLoading from 'buefy/src/components/loading/Loading.vue';
import BField from 'buefy/src/components/field/Field.vue';
import {MAFUser} from '@/store/User/types';
import {DateTime} from 'luxon';

// TODO: fix
/* tslint:disable:no-empty */

const userPath = 'userState';
const userNamespace = namespace(userPath);
const ratePath = 'rateState';
const rateNamespace = namespace(ratePath);
const friendPath = 'friendState';
const friendNamespace = namespace(friendPath);
@Component({
    components: {BIcon, BButton, BInput, BField, BLoading},
})
export default class ShareRateBody extends Vue {
    @userNamespace.State('self') public self!: MAFUser;
    @rateNamespace.State('reviewRate') public reviewRate!: ReviewRate;
    @rateNamespace.Action('upsertReview') public upsertReview: any;
    @friendNamespace.Action('sendInvite') public sendInvite: any;
    public selectedRate: number = 0;
    public updateRate: ReviewRate = new ReviewRate(null);
    public showError: boolean = false;
    public hasSet: boolean = false;
    public showLoading: boolean = false;
    public showInviteLoading: boolean = false;
    public to: string = '';
    public toErrorMessage: string = '';
    public showSuccess: boolean = false;
    constructor() {
        super();
    }

    @Watch('reviewRate', {deep: true})
    public setUpdateRate() {
        if (this.reviewRate && !this.hasSet) {
            this.hasSet = true;
            this.updateRate = new ReviewRate(this.reviewRate);
            this.selectedRate = this.updateRate.rate;

        }
    }

    public setRate(rateStar: number, click: boolean) {
        this.updateRate.rate = rateStar;
        if (click) {
            this.selectedRate = rateStar;
        }
    }


    public async submit() {
        if (this.updateRate.rate <= 0) {
            this.showError = true;
            return;
        }
        this.showError = false;
        this.showLoading = true;
        this.updateRate.date = DateTime.local().toJSDate();
        this.updateRate.userId = this.self.uid ? this.self.uid : '';
        this.updateRate.userRef = this.$firestore.collection('users').doc(this.self.uid);
        await this.upsertReview({body: this.updateRate.toPlainObj(), uid: this.updateRate.userId});
        this.hasSet = false;
        this.updateRate.review = '';
        this.updateRate.rate = 0;
        this.showLoading = false;
        this.showSuccess = true;

    }
    public async invite(e: any) {
        e.preventDefault();
        this.showInviteLoading = true;
        if (!this.to) {
            this.toErrorMessage = 'This is required to send an invite.';
            return;
        }
        this.toErrorMessage = '';
        const {res, err} = await this.sendInvite(this.to);
        this.showInviteLoading = false;
        if (err) {
            this.toErrorMessage = err.message;
        }

    }


    @Emit('close')
    public close() {
    }
}
